import { Outlet } from "react-router-dom";

export default function WithoutHeaderLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Outlet />
    </div>
  );
}
